import React, { Fragment } from "react";
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
} from "react-bootstrap";
import { Formik, Form, Field } from "formik";

const intialFormValues = {
  key: "",
};

export function AddFeatureKeyModal({
  show,
  selectedFamily,
  onFormSubmit,
  onModalClose,
}) {
  return (
    <Modal show={show} onHide={onModalClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>Add new Feature Key</Modal.Title>
      </Modal.Header>
      <Formik initialValues={intialFormValues} onSubmit={onFormSubmit}>
        {({ handleSubmit, isSubmitting }) => (
          <Fragment>
            <Modal.Body>
              <Form className="form-horizontal">
                <FormGroup controlId="family">
                  <Col componentClass={ControlLabel} sm={3}>
                    Unit Family
                  </Col>
                  <Col sm={9}>
                    <FormControl.Static>{selectedFamily}</FormControl.Static>
                  </Col>
                </FormGroup>
                <Field name="key">
                  {({ field, form: { touched, errors } }) => (
                    <FormGroup controlId="key">
                      <Col componentClass={ControlLabel} sm={3}>
                        Key
                      </Col>
                      <Col sm={9}>
                        <FormControl
                          componentClass="textarea"
                          maxLength="128"
                          rows="3"
                          style={{ resize: "none" }}
                          {...field}
                        />
                      </Col>
                    </FormGroup>
                  )}
                </Field>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsClass="btn btn-grey"
                onClick={onModalClose}
                disabled={isSubmitting}
              >
                Close
              </Button>
              <Button
                bsStyle="primary"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                Save {isSubmitting && <i className="fa fa-spinner fa-spin" />}
              </Button>
            </Modal.Footer>
          </Fragment>
        )}
      </Formik>
    </Modal>
  );
}
